module.exports = __webpack_public_path__ + "f044074d6b860ffed3509d1f10eb4501.pdf";